var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef } from 'react';
import { GenericComponent } from '../components/atoms/GenericComponent';
import useDesign from '../hooks/useDesign';
import { FactoryInstance } from './Factory';
export var FactoryComponent = forwardRef(function (_a, ref) {
    var component = _a.component, props = __rest(_a, ["component"]);
    var _b = useDesign(props.design), config = _b.config, schema = _b.schema;
    var componentInstance = component || config.component;
    var Component = FactoryInstance.getComponent(componentInstance);
    var isInvalidInstance = componentInstance && Component === GenericComponent;
    if (process.env.NODE_ENV === 'production' && isInvalidInstance) {
        throw new Error("Component \"".concat(String(componentInstance), "\" was not registered into the factory, but some design is trying to use it."));
    }
    if (isInvalidInstance) {
        console.error("Component \"".concat(String(componentInstance), "\" was not registered into the factory, but some design is trying to use it."));
    }
    return (_jsx(Component, __assign({ "data-design": props.design, ref: ref, schema: schema }, props), props.design));
});
